import Vue from 'vue'
import Router from 'vue-router'
import Login from "@/view/login/login";
import index from "@/view/index/index";
import summary from "@/view/summary/summary";
import FictionStatistics from "@/view/FictionStatistics/Fictionstatistics";
import RechargeRecord from "@/view/RechargeRecord/RechargeRecord";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      children:[{
        path:'summary',
        name:'summary',
        component:summary
      },
      {
        path:'FictionStatistics',
        name:'FictionStatistics',
        component:FictionStatistics
      },
      {
        path:'RechargeRecord',
        name:'RechargeRecord',
        component:RechargeRecord
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js